var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitorSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44667 9.3335H2.66667C1.93333 9.3335 1.33333 9.9335 1.33333 10.6668V14.0002C1.33333 14.3668 1.63333 14.6668 2 14.6668H4.44667C4.81333 14.6668 5.11333 14.3668 5.11333 14.0002V10.0002C5.11333 9.6335 4.81333 9.3335 4.44667 9.3335Z",
    fill: "#717680"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88667 6.6665H7.10667C6.37333 6.6665 5.77333 7.2665 5.77333 7.99984V13.9998C5.77333 14.3665 6.07333 14.6665 6.44 14.6665H9.55333C9.92 14.6665 10.22 14.3665 10.22 13.9998V7.99984C10.22 7.2665 9.62667 6.6665 8.88667 6.6665Z",
    fill: "#717680"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.3335H11.5533C11.1867 11.3335 10.8867 11.6335 10.8867 12.0002V14.0002C10.8867 14.3668 11.1867 14.6668 11.5533 14.6668H14C14.3667 14.6668 14.6667 14.3668 14.6667 14.0002V12.6668C14.6667 11.9335 14.0667 11.3335 13.3333 11.3335Z",
    fill: "#717680"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0067 3.23348C10.2133 3.02682 10.2933 2.78015 10.2267 2.56682C10.16 2.35348 9.95333 2.20015 9.66 2.15348L9.02 2.04682C8.99333 2.04682 8.93333 2.00015 8.92 1.97348L8.56667 1.26682C8.3 0.726816 7.69333 0.726816 7.42667 1.26682L7.07333 1.97348C7.06667 2.00015 7.00667 2.04682 6.98 2.04682L6.34 2.15348C6.04667 2.20015 5.84667 2.35348 5.77333 2.56682C5.70667 2.78015 5.78667 3.02682 5.99333 3.23348L6.48667 3.73348C6.51333 3.75348 6.53333 3.83348 6.52667 3.86015L6.38667 4.47348C6.28 4.93348 6.45333 5.14015 6.56667 5.22015C6.68 5.30015 6.92667 5.40682 7.33333 5.16682L7.93333 4.81348C7.96 4.79348 8.04667 4.79348 8.07333 4.81348L8.66667 5.16682C8.85333 5.28015 9.00667 5.31348 9.12667 5.31348C9.26667 5.31348 9.36667 5.26015 9.42667 5.22015C9.54 5.14015 9.71333 4.93348 9.60667 4.47348L9.46667 3.86015C9.46 3.82682 9.48 3.75348 9.50667 3.73348L10.0067 3.23348Z",
    fill: "#717680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitorSearch);
export default __webpack_public_path__ + "static/media/competitor-search.ea8c1891d8c19ba617d30442886faf21.svg";
export { ForwardRef as ReactComponent };